import { faList } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { AddProductToMenuAPI } from '../../Api/SupplierServices'
import { errorToast, succToast } from '../../Utils/Toast/Toast'
import Button from '../Button/Button'
import Input from '../Input/Input'
import Style from './AddTitleMenu.module.css'
const AddTitleMenu = ({UpdateList}) => {
    const [title,setTitle]=useState('')
    
    const AddProductToMenu=()=>{
        if(title===''){
            errorToast('لطفا تیتر را وارد کنید')
        }
        else{
         let categoryInfo={
             category:title,
         }
         AddProductToMenuAPI(categoryInfo,(succ)=>{
             if(succ){
                 succToast(succ.message)
                 setTitle('')
                 UpdateList()
             }
             else{
                 errorToast(succ.message)
             }
         })
        }
 
 
     }
    return (
        <section className={Style.componentHolder}>
           <p>:افزودن دسته بندی جدید<FontAwesomeIcon icon={faList}/></p> 
           <Input value={title} placeholder={'تیتر دسته بندی...'} onChange={e=>setTitle(e.target.value)}/>
           <Button Value={'ثبت'} ClassBtn={'confirmBtn'}  ClickHandler={AddProductToMenu}/>
        </section>
    )
}

export default AddTitleMenu
